module.exports = __webpack_public_path__ + "img/白堽乡-c.689184e8.png";